"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runTest = runTest;
exports.deleteTestRow = deleteTestRow;
exports.addTestRow = addTestRow;
exports.setReferenceGenesysNo = setReferenceGenesysNo;
exports.setTestGenesysNo = setTestGenesysNo;
exports.setRunningSize = setRunningSize;
exports.toggleNode = toggleNode;
exports.updateTestSystem = updateTestSystem;
exports.importSystems = importSystems;
function runTest() {
    return {
        type: "system-compare/RUN-TEST"
    };
}
function deleteTestRow(index) {
    return {
        type: "system-compare/DELETE-TEST-ROW",
        index: index
    };
}
function addTestRow() {
    return {
        type: "system-compare/ADD-TEST-ROW"
    };
}
function setReferenceGenesysNo(text, index) {
    return {
        type: "system-compare/SET-REFERENCE-GENESYS-NO",
        text: text,
        index: index
    };
}
function setTestGenesysNo(text, index) {
    return {
        type: "system-compare/SET-TEST-GENESYS-NO",
        text: text,
        index: index
    };
}
function setRunningSize(size) {
    return {
        type: "system-compare/SET-RUNNING-SIZE",
        size: size
    };
}
function toggleNode(testId, path) {
    return {
        type: "system-compare/TOGGLE-NODE",
        testId: testId,
        path: path
    };
}
function updateTestSystem(systemTestRow) {
    return {
        type: "system-compare/UPDATE-TEST-SYSTEM",
        systemTestRow: systemTestRow
    };
}
function importSystems(systemsToimport) {
    return {
        type: "system-compare/IMPORT-SYSTEMS",
        systemsToimport
    };
}
//# sourceMappingURL=actions.js.map